import { Box } from "@mui/material";

const SendingSMSLayout = ({children}) => (
  <Box className="relative z-10">
    <Box className="countdown absolute flex items-center justify-center bg-white opacity-75 rounded-full">
      {children}
    </Box>
  </Box>
)

export default SendingSMSLayout;